import React from 'react';

export const LazyTeamRoute = React.lazy(() =>
  import(/* webpackChunkName: "team" */ './Route'),
);
